import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  // { type: "section", label: "Clientes" },
  { type: "section", label: "Ventas" },
  { label: "Clientes",                 icon: "fas fa-user-tie",                    color: "#3b82f6", bg: "#eff6ff", href: "/Clientes",                        desc: "Catálogo de clientes",          perm: "menu_clientes"       },
  // { label: "Venta Directa",            icon: "fas fa-receipt",                     color: "#10b981", bg: "#f0fdf4", href: "/VentaDirectaCreate",              desc: "Captura de venta directa",      perm: "menu_pedidos"        },
  { label: "Devoluciones",             icon: "fas fa-undo-alt",                    color: "#f97316", bg: "#fff7ed", href: "/ListadoDevoluciones",             desc: "Devoluciones de clientes",      perm: "menu_devoluciones"   },

  // { type: "section", label: "Captura de Ventas" },
  // { label: "Venta Directa",            icon: "fas fa-receipt",                     color: "#10b981", bg: "#f0fdf4", href: "/VentaDirectaCreate",              desc: "Captura de venta directa",      perm: "menu_pedidos"        },
  // { label: "Venta Directa Archivo",    icon: "fas fa-file-upload",                 color: "#10b981", bg: "#f0fdf4", href: "/VentaDirectaArchivoCreate",       desc: "Cargar ventas por archivo",     perm: "menu_pedidos"        },
  // { label: "Pedidos",                  icon: "fas fa-shopping-basket",             color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPedidos",                  desc: "Órdenes de venta",              perm: "menu_pedidos"        },

  // { type: "section", label: "Surtido y Entregas" },
  // { label: "Surtir",                   icon: "fas fa-truck-moving",                color: "#ef4444", bg: "#fef2f2", href: "/ListadoPendienteSurtir",          desc: "Pedidos pendientes de surtir",  perm: "surtidos_create"     },
  // { label: "Notas",                    icon: "fas fa-file-invoice-dollar",         color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoSurtidos",                 desc: "Notas de remisión",             perm: "menu_surtidos"       },
  // { label: "Devoluciones",             icon: "fas fa-undo-alt",                    color: "#f97316", bg: "#fff7ed", href: "/ListadoDevoluciones",             desc: "Devoluciones de clientes",      perm: "menu_devoluciones"   },

  { type: "section", label: "Reprotes" },
  { label: "Último Precio Cliente",    icon: "fas fa-dollar-sign",                 color: "#6366f1", bg: "#eef2ff", href: "/ReporteUltimoPrecio",             desc: "Precio histórico por cliente",  perm: "menu_pedidos"        },
  { label: "Último Precio Artículo",   icon: "fas fa-box",                      color: "#6366f1", bg: "#eef2ff", href: "/ReporteUltimoPrecioArticulo",     desc: "Precio histórico por artículo", perm: "menu_pedidos"        },

  // { type: "section", label: "Análisis de Ventas" },
  // { label: "Ventas Artículo",          icon: "fa-solid fa-chart-gantt",            color: "#10b981", bg: "#f0fdf4", href: "/ReporteVentasArticulo",           desc: "Ventas con utilidad por artículo", perm: "menu_pedidos"     },
  // { label: "Ventas Artículo Agrupado", icon: "fa-solid fa-chart-bar",              color: "#3b82f6", bg: "#eff6ff", href: "/ReporteVentasArticuloAgrupado",   desc: "Ventas agrupadas por artículo", perm: "menu_pedidos"        },
  // { label: "Ventas Artículos MP",      icon: "fa-solid fa-chart-line",             color: "#0ea5e9", bg: "#f0f9ff", href: "/ReporteVentasArticuloMP",         desc: "Ventas de materia prima",       perm: "menu_pedidos"        },
  // { label: "Ventas MP Agrupado",       icon: "fa-solid fa-chart-column",           color: "#0ea5e9", bg: "#f0f9ff", href: "/ReporteVentasArticuloMPAgrupado", desc: "MP agrupado",                   perm: "menu_pedidos"        },
  // { label: "Análisis Productos",       icon: "fa-solid fa-magnifying-glass-chart", color: "#8b5cf6", bg: "#f5f3ff", href: "/AnalisisGeneralProductos",        desc: "Análisis general de productos", perm: "menu_pedidos"        },
  // { label: "Ventas Artículo Gastos",   icon: "fa-solid fa-chart-gantt",            color: "#ec4899", bg: "#fdf2f8", href: "/ReporteVentasArticuloGastos",     desc: "Ventas con gastos por artículo", perm: "menu_pedidos"       },
];

function BotonesVentas() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS =
    process.env.REACT_APP_URL_EMPRESAS ||
    (process.env.REACT_APP_URL_AREAS || "").replace("areas", "empresas");

  // Un card de Ventas por empresa: /ListadoVentas/:idEmpresa
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setEmpresas(
          (res.data || [])
            .filter((e) => e.is_active !== "No")
            .sort((a, b) => (a.name > b.name ? 1 : -1))
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const cardsEmpresas = empresas.map((e) => ({
    label: `Ventas ${e.name}`,
    icon: "fas fa-file-invoice-dollar",
    color: "#8b5cf6",
    bg: "#f5f3ff",
    href: `/ListadoVentas/${e._id}`,
    desc: `Notas de remisión de ${e.name}`,
    perm: "menu_surtidos",
  }));

  // Los cards por empresa entran en la seccion Ventas, despues de Clientes
  const items = [...ITEMS];
  items.splice(2, 0, ...cardsEmpresas);

  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-cash-register" color="#10b981" bg="#f0fdf4" title="Ventas" subtitle="Pedidos, surtidos y clientes" />
        {user.menu_ventas ? (
          <div className="row">
            {items.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesVentas;
